import React from 'react';

import type { PaymentProcessor } from '../../core/payment-processor';
import type {
    AvailablePaymentMethodsV1Dto,
    PaymentWidgetContainerProps
} from '../../types';
import { PaymentWidgetCoreWithErrorBoundary } from './payment-widget-core';

interface Props {
    methodType: PaymentWidgetContainerProps['methodType'];
    paymentProcessor: PaymentProcessor;
    availablePaymentMethods?: AvailablePaymentMethodsV1Dto[];
    onSuccess?: PaymentWidgetContainerProps['onSuccess'];
    onBack?: PaymentWidgetContainerProps['onBack'];
    onPaymentSuccess?: PaymentWidgetContainerProps['onPaymentSuccess'];
}

export const PaymentWidgetContainer: React.FC<Props> = ({
    methodType,
    paymentProcessor,
    availablePaymentMethods,
    onBack,
    onPaymentSuccess
}) => {
    return (
        <PaymentWidgetCoreWithErrorBoundary
            methodType={methodType}
            paymentProcessor={paymentProcessor}
            availablePaymentMethods={availablePaymentMethods}
            onBack={onBack}
            onPaymentSuccess={onPaymentSuccess}
        />
    );
};
